import { render, staticRenderFns } from "./admin-statistic-certificates-issued-per-provider.vue?vue&type=template&id=6f399407&scoped=true"
import script from "./admin-statistic-certificates-issued-per-provider.vue?vue&type=script&lang=js"
export * from "./admin-statistic-certificates-issued-per-provider.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f399407",
  null
  
)

export default component.exports